var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GenericSearch',_vm._g(_vm._b({},'GenericSearch',{ options: _vm.options },false),{ search: _vm.search, select: _vm.select }))
}
var staticRenderFns = []

export { render, staticRenderFns }